import { ErrorMessageProvider } from '@mvf/external-components';
import ErrorMessage from '@ErrorMessage';
import React from 'react';
import { useSelector } from 'react-redux';
import useGetExperimentName from '../../Hooks/useGetExperimentName/useGetExperimentName';

const SubmissionError = () => {
  const { error } = useSelector((store) => store.submission);

  const isSubmissionError = !!error.message;
  const errorMessageProviderExperimentName = useGetExperimentName({
    componentName: 'ErrorMessageProvider',
  });
  const errorMessageExperimentName = useGetExperimentName({
    componentName: 'ErrorMessage',
  });

  if (!isSubmissionError) {
    return null;
  }

  return (
    <ErrorMessageProvider
      errorMessage={error.message}
      experimentName={errorMessageProviderExperimentName}
    >
      <ErrorMessage experimentName={errorMessageExperimentName} />
    </ErrorMessageProvider>
  );
};
export default SubmissionError;
